import { Component } from '@angular/core';

import { CustomerDataV2, CustomerNode, CustomerSubCustomer, Deal, FlatCustomerNode, SelectedCustomer, vehicle} from '../models/customer';
import { CustomerService } from '../customers/customer.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { FlatTreeControl } from '@angular/cdk/tree';
import { NzTreeFlatDataSource, NzTreeFlattener } from 'ng-zorro-antd/tree-view';
import { SelectionModel } from '@angular/cdk/collections';
import { AuthService } from '../auth.service';
import { NotificationService } from '../shared/notification.service';



@Component({
  selector: 'app-customer',
  templateUrl: './customerInfo.component.html',
  styleUrls: ['./customerInfo.component.less']
})
export class CustomerInfoComponent {

  routeParamSub: Subscription;

  selectedVehicleId: number;
  selectedVReg: string;
  cusData = JSON.parse(localStorage.getItem('customerData')!);

  currentCustomer: CustomerDataV2 | undefined;

  selectListSelection = new SelectionModel<FlatCustomerNode>(true);

  treeControl = new FlatTreeControl<FlatCustomerNode>(node => node.level, node => node.expandable);

       private transformer = (node: CustomerNode, level: number): FlatCustomerNode  => ({
        expandable: !!node.subcustomers && node.subcustomers.length > 0,
        name: node.name,
        level,
        disabled: !!node.disabled,
        customerId: node.customerId,
        cell: node.cell,
        email: node.email
    
      });

  treeFlattener = new NzTreeFlattener(
      this.transformer,
      node => node.level,
      node => node.expandable,
      node => node.subcustomers
    );

  hasChild = (_: number, node: FlatCustomerNode): boolean => node.expandable;

  subCustomerDataSource = new NzTreeFlatDataSource(this.treeControl, this.treeFlattener);

  customerSubCustomerData: CustomerNode[] = [];
    
  dealLineItemsSummary: any[] = [];

  importantVehicles: vehicle[] = [];
  dueForAlignment: vehicle[] = [];
  dueForService: vehicle[] = [];
  dueForTyreChange: vehicle[] = [];
  dueForBalance: vehicle[] = []

  vehicleFilters: { text: any; value: any }[] = [];
  sizeFilters: { text: any; value: any }[] = [];
  statusFilters: { text: any; value: any }[] = [];
  salesmanFilterTerms: { text: any; value: any }[] = [];

  vehicleFilterFn = (list: string[], item: any) => list.some(v => item.vreg === v);
  sizeFilterFn = (list: string[], item: any) => list.some(v => item.lineItems[0]?.size === v);
  statusFilterFn = (list: string[], item: any) => list.some(v => item.status === v);
  sortByDate = (a: any, b: any) => new Date(b.dtCreated).getTime() - new Date(a.dtCreated).getTime();
  salesmanFilterFn = (list: string[], item: any) => list.some(v => item.salesmanName === v);

  quoteVsSaleColor: string;
  totalSpendColor: string;
  totalSpendInterval: string;
  avgSpendInterval: string;
  avgSpendColor: string;
  firstAndLastPurchaseDateColor: string;
  customerLifeTime: string;
  tierColor: string;
  isThisSalesMan: boolean = false;
  maintenanceAlerts: number = 0;
  quoteVsSale: number = 0;
  favouriteTyreBrandTier: string = '';

  constructor(private activatedRoute: ActivatedRoute, private customerService: CustomerService, private router: Router, private auth: AuthService, private notification: NotificationService) { }

  ngOnInit() {
    this.routeParamSub = this.activatedRoute.params.subscribe(params => {
      let customerIdParam: number

      if (params['customerId']) {
        customerIdParam = params['customerId'];
        this.getCustomerData(customerIdParam);

      }

      else { 
        customerIdParam = this.cusData.sendTo === undefined
          ? this.cusData.customerId
          : this.cusData.customer;

        if (this.cusData.vreg && this.cusData.vreg !== '') {
          this.selectedVReg = this.cusData.vreg;
        }
        this.getCustomerData(customerIdParam);
      }
    });    
  }

  getCustomerData(customerParams: number) {
  this.customerService.getCustomerData(customerParams)
    .subscribe({next: (data: CustomerDataV2) => {
      this.currentCustomer = data;

      this.customerSubCustomerData = this.buildSubCustomerTree(this.currentCustomer.subCustomers);
      this.subCustomerDataSource.setData(this.customerSubCustomerData)
      this.checkVehicles(this.currentCustomer.vehicles);

      this.vehicleFilters = data.vehicleFilterTerms.map(term => ({ text: term, value: term }));
      this.sizeFilters = data.sizeFilterTerms.map(term => ({ text: term, value: term }));
      this.statusFilters = data.statusFilterTerms.map(term => ({ text: term, value: term }));
      this.salesmanFilterTerms = data.salesmanFilterTerms.map(term => ({ text: term, value: term }));
      
      this.quoteVsSaleColor = this.getQuoteVsSaleColor(data.quotes.length, data.sales.length);
      this.totalSpendColor = this.getSpendColor(data.ltv);
      this.avgSpendColor = this.getAvgSpendColor(data.averageSpend);
      this.firstAndLastPurchaseDateColor = this.getLastPurchaseDateColor(data.firstPurchase, data.lastPurchase);
      this.maintenanceAlerts = this.getMaintenaceAlerts();
      this.tierColor = this.getBrandTierColor(data.mostFrequentTyreBrandTier);
      this.isThisSalesMan = data.mostRecentSalesman === this.auth.user.fullname
      this.quoteVsSale = data.quotes.length > 0 ? Math.round((data.sales.length / data.quotes.length) * 100) : 0;
      // store customer data
      this.customerService.selectedCustomer = new SelectedCustomer();
      this.customerService.selectedCustomer.customerId = this.currentCustomer.customer.customerId;
      this.customerService.selectedCustomer.name = this.currentCustomer.customer.name;
      this.customerService.selectedCustomer.email = this.currentCustomer.customer.email;
      this.customerService.selectedCustomer.cell = this.currentCustomer.customer.cell;
      this.customerService.selectedCustomer.VATNumber = this.currentCustomer.customer.VATNumber;
    }, error: (err) => {
      this.notification.handleError(err);
    }
    });
  }

navigateToCustomer(customerId: number) {
  this.currentCustomer = undefined;
  this.router.navigate([`/customer/${customerId}`]);
}

buildSubCustomerTree(data: CustomerSubCustomer[]): CustomerNode[] {
  return data.map(customer => ({
    name: customer.name,
    customerId: customer.customerId,
    cell: customer.cell,
    email: customer.email,
    subcustomers: customer.subcustomers ? this.buildSubCustomerTree(customer.subcustomers) : []
  }));
}

openCustomer() {
  if (this.currentCustomer) {
    this.router.navigate(['/settings/customer-edit', this.currentCustomer.customer.customerId]);
  }
} 

get hasSubCustomers() { 
  if (!this.currentCustomer) {
    return false;
  }
  return this.currentCustomer?.subCustomers?.length > 0;
}

getDealSummary(deal : Deal){
  const summary: string[] = [];
  if (this.currentCustomer) {
    for (const item of deal.lineItems) {
      if (item.stockTypeId === 1 && summary.indexOf(item.stockTypeImage) === -1) {
        summary.push(item.brand ? item.brand : '');
      } else if (item.stockTypeId !== 1 && item.stockTypeImage && summary.indexOf(item.stockTypeImage) === -1) {
      summary.push(item.stockTypeImage ? item.stockTypeImage : '');
      }

    }
    if (summary.length < 1) {
      summary.push("sf:other1");
    }
    return summary;
  }
  else {
    return ['No Deal Summary Available'];
  }
}

checkTyreDt(date: Date | null): boolean {
  if (!date) return false;
  const dateToCheck: Date = new Date(date);
  const threeYearAgo = new Date();
  threeYearAgo.setFullYear(threeYearAgo.getFullYear() - 3);
  return dateToCheck < threeYearAgo;
}

checkAlignmentBalancingDt(date: Date | null): boolean {
  if (!date) return false;
  const dateToCheck: Date = new Date(date);
  const oneYearAgo = new Date();
  oneYearAgo.setFullYear(oneYearAgo.getFullYear() - 1);
  return dateToCheck < oneYearAgo;
  }


getSpendColor(amount: number): string {
  if (amount > 50000) {
    this.totalSpendInterval = '> R50 000';
    return 'green';
  } else if (amount > 10000) {
    this.totalSpendInterval = 'R10 000 - R50 000';
    return 'orange';
  } else {
    this.totalSpendInterval = '< R10 000';
    return 'red';
  }
}

getAvgSpendColor(amount: number): string {
  if (amount > 10000) {
    this.avgSpendInterval = '> R10 000';
    return 'green'; 
  } else if (amount > 1000) {
    this.avgSpendInterval = 'R1 000 - R10 000';
    return 'orange'; 
  } else {
    this.avgSpendInterval = '< R1 000';
    return 'red'; 
  }
}

getLastPurchaseDateColor(fDate: Date | null, lDate: Date | null): string {
  if (!fDate || !lDate) {
    return 'none';
  }
  const first = new Date(fDate);
  const now = new Date();
  const diffYears = (now.getTime() - first.getTime()) / (1000 * 60 * 60 * 24 * 365.25);
  if (diffYears > 3) {
    this.customerLifeTime = '> 3 years';
    return 'green';
  } else if (diffYears > 1) {
    this.customerLifeTime = '1 - 3 years';
    return 'orange';
  } else {
    this.customerLifeTime = '< 1 year';
    return 'none';
  }
}

getQuoteVsSaleColor(quotes: number, sales: number): string {
 const ratio = sales / (quotes || 1);
  if (ratio > 0.75) {
    return 'green'; 
  }
  else if (ratio >= 0.5) {
    return 'orange'; 
  } else {
    return 'red'; 
  }
}

getBrandTierColor(tier: string): string {
  switch (tier) {
    case 'T01':
      this.favouriteTyreBrandTier = 'Premium';
      return 'green';
    case 'T02':
      this.favouriteTyreBrandTier = 'Value';
      return 'orange';
    default:
      this.favouriteTyreBrandTier = 'Budget';
      return 'none';
  }
  }

checkVehicles(customerVehicles: vehicle[]) {
  this.importantVehicles = [];
  if (customerVehicles && Array.isArray(customerVehicles)) {
    for (const v of customerVehicles) {
      if (v.lastAlignmentDt && this.checkAlignmentBalancingDt(new Date(v.lastAlignmentDt))) {
        if (!this.importantVehicles) {
          this.importantVehicles = [];
        }
        this.dueForAlignment.push(v);
      }
      if (v.lastTyreChangeDt && this.checkTyreDt(new Date(v.lastTyreChangeDt))) {
        if (!this.importantVehicles) {
          this.importantVehicles = [];
        }
        this.dueForTyreChange.push(v);
      }
      if (v.lastBalancingDt && this.checkAlignmentBalancingDt(new Date(v.lastBalancingDt))) {
        if (!this.importantVehicles) {
          this.importantVehicles = [];
        }
        this.dueForBalance.push(v);
      }
    }
  }
}

getMaintenaceAlerts() {
  const alerts : number = this.dueForAlignment.length + this.dueForService.length + this.dueForTyreChange.length + this.dueForBalance.length;
  if (alerts > 0) {
    return alerts;
  }
  return 0;

}

getVehicleSummary(vreg: string) {
  if (this.currentCustomer && this.currentCustomer.vehicles) {
    const vehicle = this.currentCustomer.vehicles.find(v => v.vreg === vreg);
    if (vehicle) {
      const summary = `${vehicle.make ? vehicle.make : ''} ${vehicle.model ? vehicle.model : ''} ${vehicle.year ? '(' + vehicle.year + ')' : ''}`
      return summary.length>3 ? summary : 'No Vehicle Summary Available';
    }   
  }
  return 'No Vehicle Summary Available';
}

calculateCustomerScore(customer: CustomerDataV2): number {
  if (!customer || !customer.sales || customer.sales.length === 0) {
    return 0; 
  }

  const totalSales = customer.sales.reduce((sum, sale) => sum + (sale.price || 0), 0);
  const totalQuotes = customer.quotes.reduce((sum, quote) => sum + (quote.price || 0), 0);

  if (totalQuotes === 0) {
    return 0; 
  }

  const score = (totalSales / totalQuotes) * 100; 
  return Math.round(score); 

}

  routeQuote(quoteid)
  {
    this.router.navigate(["/pos/v2",quoteid],{queryParams: {cid: this.currentCustomer?.customer.customerId}});
  }

  routeSale(orderid)
  {
    this.router.navigate(["/sales/view",orderid])
  }

  selectedTabIndex: number = 0;

goToOpenQuotes() {
  this.selectedTabIndex = 0;

}
}